import { createSvgIcon } from '@mui/material';

const IconSprint = createSvgIcon(
  <svg xmlns="http://www.w3.org/2000/svg" width="50" height="50" viewBox="0 0 50 50">
    <g id="Group_10685" data-name="Group 10685" transform="translate(-1094 -1924)">
      <g id="Group_10187" data-name="Group 10187" transform="translate(-16 -42)">
        <rect
          id="Rectangle_5273"
          data-name="Rectangle 5273"
          width="50"
          height="50"
          rx="25"
          transform="translate(1110 1966)"
          fill="#f7f8f8"
        />
      </g>
      <g id="Group_6492" data-name="Group 6492" transform="translate(211.085 -1684.563)">
        <g id="Group_6412" data-name="Group 6412" transform="translate(889.591 3624.475)">
          <g id="Group_6394" data-name="Group 6394" transform="translate(0 0)">
            <path
              id="Path_3427"
              data-name="Path 3427"
              d="M96.752,38.291l9.352,0s6.714-.269,9.6-8.727l.408-4.791,1.343-.671-1.481-3.4-4.3,1.41v1.653l1.156,1.664S110,27.42,110,30.374v1.569a2.322,2.322,0,0,1-2.322,2.322h-2.659a3.2,3.2,0,0,1-2.808-1.665l-.549-1a1.325,1.325,0,0,1,.28-1.624l3.156-2.824H95.121"
              transform="translate(-95.121 -20.708)"
              fill="none"
              stroke="#9697ad"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="1.5"
            />
            <line
              id="Line_902"
              data-name="Line 902"
              x1="2.48"
              transform="translate(13.738 2.283)"
              fill="none"
              stroke="#9697ad"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="1.5"
            />
            <path
              id="Path_3428"
              data-name="Path 3428"
              d="M117.65,43.754h5.068l2.047-2.047h3.586a5.456,5.456,0,0,0-4.719-4.184"
              transform="translate(-103.514 -26.972)"
              fill="none"
              stroke="#9697ad"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="1.5"
            />
            <path
              id="Path_3429"
              data-name="Path 3429"
              d="M129.188,44.306a3.457,3.457,0,1,1-5.866,2.479"
              transform="translate(-105.627 -29.499)"
              fill="none"
              stroke="#9697ad"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="1.5"
            />
            <line
              id="Line_903"
              data-name="Line 903"
              x2="6.578"
              transform="translate(3.599 4.005)"
              fill="none"
              stroke="#9697ad"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="1.5"
            />
          </g>
        </g>
        <g id="logo-99minutos.6ca31ef5" transform="translate(887.174 3612.617)">
          <path
            id="Fill-14"
            d="M154.558,94.6l3.175-3.175S155.685,86.2,148.31,81.9l-3.175,3.175,3.687,3.687-.82.82a19.253,19.253,0,0,0-31.752,14.749,19.256,19.256,0,1,0,33.9-12.6l.819-.819Zm-3.995,9.423a15.108,15.108,0,1,1-15.056-15.262,15.212,15.212,0,0,1,15.056,15.262Z"
            transform="translate(-116.251 -81.9)"
            fill="#9697af"
          />
        </g>
      </g>
    </g>
  </svg>,

  'IconSprint',
);

export default IconSprint;
